export { Channel };
class Channel {
    constructor({ path, width, length }) {
        this.path = path;
        this.width = width;
        this.length = length !== null && length !== void 0 ? length : path.length;
    }
}
//# sourceMappingURL=Channel.js.map